<div>
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div>{{ caption }}</div>
</div>
<div>
  <dx-select-box
    [dataSource]="dataSource"
    [(value)]="value"
    displayExpr="name"
    [valueExpr]="valueKey ? 'name' : 'id'"
    [showClearButton]="true"
    [searchEnabled]="true"
    [disabled]="isDisabled">
    <dx-validator>
      @if (mandatory === true) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-select-box>
</div>
